import { isString } from 'lodash-es';

const WORDS = [
	'ResizeObserver loop',
	'User not login',
	'Unable to find node on an unmounted component',
];

/**
 * 错误消息是否需要过滤
 * @param error
 * @returns
 */
export const isExpectFiltered = (error: any) => {
	const message = error?.message;
	if (!isString(message)) return false;

	return WORDS.some((word) => message.includes(word));
};
